// src/features/admin/AdminPlaceholderPanel.jsx
//
// Slice Adm1: minimal placeholder for sub-sidebar sections that
// haven't been implemented yet (Integrations, Audit log, Role
// management). Same visual rhythm as the real panels — section title
// at top, one-line muted description below — so the chrome reads
// consistently as the user clicks across sections.
//
// No new tokens, no new deps. The "Coming in a future release."
// string is on purpose generic — when a section ships, the whole
// component goes away (replaced in AdminPage's dispatch table) and
// this file does NOT need a per-section special case.

import React from "react";
import { T } from "../../app/tokens.js";

/**
 * @param {object} props
 * @param {string} props.sectionKey   stable key (used for testid)
 * @param {string} props.section      display name (e.g. "Integrations")
 * @param {string} props.description  one-line copy explaining what'll land here
 */
export function AdminPlaceholderPanel({ sectionKey, section, description }) {
  return (
    <div data-testid={`admin-placeholder-${sectionKey}`}>
      <div style={{ fontSize: T.fsLg5, fontWeight: T.fwSemibold, color: T.dark, marginBottom: 6 }}>
        {section}
      </div>
      <div style={{ fontSize: T.fsSm, color: T.mid, marginBottom: 28, lineHeight: 1.5 }}>
        {description}
      </div>
      <div
        style={{
          padding: "48px 24px",
          textAlign: "center",
          color: T.light,
          fontSize: T.fsBase,
          background: T.bg,
          border: `0.5px solid ${T.border}`,
          borderRadius: 6,
        }}
      >
        Coming in a future release.
      </div>
    </div>
  );
}
